module.exports = __webpack_public_path__ + "img/gogogiving-banner-600.77ed71b0.webp";